import { __rest } from 'tslib';
import React from 'react';
import { SkipForwardIcon, SkipBackwardIcon, LinkIcon, ArticleIcon, PauseIcon, PlayIcon, SearchIcon, BurgerIcon, CloseIcon } from '../Icons/ButtonIcons/ButtonIcons.mjs';
import { StyledIconButton, IconContainer } from './IconButton.styles.mjs';

const renderIcon = ({ iconType, children = null, color }) => {
    switch (iconType) {
        case 'close':
            return React.createElement(CloseIcon, { color: color });
        case 'burger':
            return React.createElement(BurgerIcon, { color: color });
        case 'search':
            return React.createElement(SearchIcon, { color: color });
        case 'play':
            return React.createElement(PlayIcon, { color: color });
        case 'pause':
            return React.createElement(PauseIcon, { color: color });
        case 'article':
            return React.createElement(ArticleIcon, { color: color });
        case 'link':
            return React.createElement(LinkIcon, { color: color });
        case 'backward':
            return React.createElement(SkipBackwardIcon, { color: color });
        case 'forward':
            return React.createElement(SkipForwardIcon, { color: color });
        case 'custom':
            return children;
        default:
            return null;
    }
};
const IconButtonComponent = (_a) => {
    var { children, type = 'submit', ariaLabel, onClick, disabled, color, className, iconType } = _a, styleProps = __rest(_a, ["children", "type", "ariaLabel", "onClick", "disabled", "color", "className", "iconType"]);
    return (React.createElement(StyledIconButton, Object.assign({ type: type, "aria-label": ariaLabel, className: className, onClick: onClick, disabled: disabled }, styleProps),
        React.createElement(IconContainer, null, renderIcon({ iconType, children, color }))));
};

export { IconButtonComponent as default };
//# sourceMappingURL=IconButton.mjs.map
